import { useState, type ReactNode } from "react";

import { cn } from "@/lib/utils";

function initialsFromLabel(label: string): string {
  const parts = label.trim().split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return (parts[0]![0]! + parts[parts.length - 1]![0]!).toUpperCase();
  }
  const word = parts[0] ?? "?";
  return word.slice(0, 2).toUpperCase();
}

export function HubUserAvatar(props: {
  avatarUrl: string | null | undefined;
  label: string;
  className?: string;
  size?: "sm" | "md";
}): ReactNode {
  const [failed, setFailed] = useState(false);
  const sizeClass = props.size === "sm" ? "h-8 w-8 text-xs" : "h-9 w-9 text-xs";
  const showImage = Boolean(props.avatarUrl?.trim()) && !failed;
  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full border border-slate-200 bg-slate-100 font-semibold text-slate-600",
        sizeClass,
        props.className,
      )}
      aria-hidden
    >
      {showImage ? (
        <img
          src={props.avatarUrl!.trim()}
          alt=""
          className="h-full w-full object-cover"
          referrerPolicy="no-referrer"
          onError={() => setFailed(true)}
        />
      ) : (
        initialsFromLabel(props.label)
      )}
    </span>
  );
}
